import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';

function NewFundingConsumerAggregatorForm({ consumerAggregatorId, consumerAggregatorName }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <p className="bo-common-text text-truncate">{consumerAggregatorName || 'Loading...'}</p>
      <Link className="bo-common-text" to={`/aggregator/${consumerAggregatorId}`}>
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#5946A4" />
      </Link>
    </div>
  );
}

export default NewFundingConsumerAggregatorForm;
